(function () {
	"use strict";

	/* =====================================================
     ギャラリー：サムネイルクリックでメイン画像を切り替え
     ===================================================== */
	function initGallery(sectionId) {
		var mainImg = document.getElementById("cld-main-img-" + sectionId);
		if (!mainImg) return;

		var thumbs = document.querySelectorAll(
			'.cld-pdp-thumb[data-section="' + sectionId + '"]'
		);
		if (!thumbs.length) return;

		thumbs.forEach(function (thumb) {
			thumb.addEventListener("click", function () {
				thumbs.forEach(function (t) {
					t.classList.remove("is-active");
				});
				thumb.classList.add("is-active");
				mainImg.src = thumb.dataset.src || "";
				mainImg.srcset = thumb.dataset.srcset || "";
				mainImg.alt = thumb.dataset.alt || "";
			});
		});
	}

	/* =====================================================
     自動見積もり：数量変更に連動してリアルタイム計算
     ===================================================== */
	function initEstimate(sectionId) {
		var data = window.CLD_PRODUCT_DATA;
		if (!data) return;
		data.colorOptions =
			(window.CLD_OPTION_SETTINGS && window.CLD_OPTION_SETTINGS.colors) || [];

		var qtySelect = document.getElementById("cld-qty-" + sectionId);
		var baseEl = document.getElementById("cld-est-base-" + sectionId);
		var totalEl = document.getElementById("cld-est-total-" + sectionId);
		var taxEl = document.getElementById("cld-est-tax-" + sectionId);
		var colorValEl = document.getElementById("cld-est-color-" + sectionId);
		var colorRowEl = document.getElementById("cld-est-color-row-" + sectionId);
		var expressValEl2 = document.getElementById("cld-est-express-" + sectionId);
		var expressRowEl = document.getElementById(
			"cld-est-express-row-" + sectionId
		);
		var campaignValEl = document.getElementById("cld-est-campaign-" + sectionId);
		var campaignRowEl = document.getElementById("cld-est-campaign-row-" + sectionId);
		if (!qtySelect) return;

		function formatYen(n) {
			return "¥" + Math.round(n).toLocaleString("ja-JP");
		}

		// discount_rules の中から選択数量に適用される割引率を返す
		// アプリ（Cart Function）と同じロジック：qty以下のルールを絞り込み、
		// quantity最大のものを選ぶ（ルールの並び順に依存しない）
		function getDiscount(qty) {
			var rules = data.discountRules || [];
			var applicable = rules
				.filter(function (rule) {
					return qty >= rule.quantity;
				})
				.sort(function (a, b) {
					return b.quantity - a.quantity;
				})[0];
			return applicable ? applicable.discount : 0;
		}

		function update() {
			var qty = parseInt(qtySelect.value, 10);
			var discount = getDiscount(qty);

			// STEP 1: 特急チェック状態を取得
			var expressSurcharge = (window.CLD_OPTION_SETTINGS && window.CLD_OPTION_SETTINGS.expressSurcharge) || 0;
			var expressInputEl = document.getElementById("cld-express-val-" + sectionId);
			var isExpressOn = !!(expressInputEl && expressInputEl.value === "1" && expressSurcharge > 0);

			// STEP 2: 通常単価（掛け率適用後、特急割増なし）
			// data.price はShopifyの内部値（セント単位）なので100で割って円に変換
			var priceYen = data.price / 100;
			var priceAfterKakerate = (priceYen * discount) / 100;
			var normalUnitPrice = Math.round(priceAfterKakerate);

			// STEP 3: 印刷費小計（特急・手数料を除く）
			var printSubtotal = normalUnitPrice * qty;
			if (baseEl) baseEl.textContent = formatYen(printSubtotal);
			var subtotal = printSubtotal;

			// 色手数料（add は cents 単位）
			var colorFee = 0;
			var colorInputEl = document.getElementById("cld-color-val-" + sectionId);
			if (colorInputEl && colorInputEl.value && data.colorOptions) {
				var selectedEntry = (data.colorOptions || []).find(function (c) {
					return c.value === colorInputEl.value;
				});
				if (selectedEntry && selectedEntry.add > 0) {
					colorFee = Math.round(selectedEntry.add / 100) * qty;
				}
			}
			if (colorFee > 0) {
				if (colorRowEl) colorRowEl.classList.remove("hidden");
				if (colorValEl) colorValEl.textContent = "+" + formatYen(colorFee);
			} else {
				if (colorRowEl) colorRowEl.classList.add("hidden");
			}
			subtotal = subtotal + colorFee;

			// 特急割増分（別行表示、特急ONのときのみ）
			var expressDiff = 0;
			if (expressSurcharge > 0 && isExpressOn) {
				var expressUnitPrice = Math.round(priceYen * (1 + expressSurcharge / 100) * discount / 100);
				expressDiff = (expressUnitPrice - normalUnitPrice) * qty;
				if (expressRowEl) expressRowEl.classList.remove("hidden");
				if (expressValEl2) expressValEl2.textContent = formatYen(expressDiff);
			} else {
				if (expressRowEl) expressRowEl.classList.add("hidden");
			}
			subtotal = subtotal + expressDiff;

			// キャンペーン割引（特急ONのときはスキップ）
			var campaignDiscount = 0;
			if (!isExpressOn && data.isCampaign && data.campaignType && data.campaignValue > 0) {
				if (data.campaignType === "percent") {
					var campaignUnitPrice = Math.round(normalUnitPrice * (1 - data.campaignValue / 100));
					campaignDiscount = (normalUnitPrice - campaignUnitPrice) * qty;
				} else {
					var campaignUnitPrice = Math.round(Math.max(0, normalUnitPrice - data.campaignValue));
					campaignDiscount = (normalUnitPrice - campaignUnitPrice) * qty;
				}
			}
			if (campaignRowEl) {
				if (campaignDiscount > 0) {
					campaignRowEl.classList.remove("hidden");
					if (campaignValEl) campaignValEl.textContent = "-" + formatYen(campaignDiscount);
				} else {
					campaignRowEl.classList.add("hidden");
				}
			}
			subtotal = subtotal - campaignDiscount;

			// STEP 3: 消費税 = 小計 × 0.1 → 切り捨て
			var tax = Math.floor(subtotal * 0.1);

			// STEP 4: 合計（税込）= 小計 + 消費税
			var total = subtotal + tax;

			if (totalEl) totalEl.textContent = formatYen(total);
			if (taxEl) taxEl.textContent = formatYen(tax);
		}

		// 他のコンポーネントから呼び出せるよう公開
		document.getElementById("cld-estimate-" + sectionId).dataset.update = "";
		document.getElementById("cld-estimate-" + sectionId)._triggerUpdate =
			update;

		qtySelect.addEventListener("change", update);

		update(); // 初期表示
	}

	/* =====================================================
     名入れ色選択ポップアップ
     ===================================================== */
	function initColorPicker(sectionId) {
		var field = document.getElementById("cld-color-field-" + sectionId);
		var trigger = document.getElementById("cld-color-trigger-" + sectionId);
		var hiddenInput = document.getElementById("cld-color-val-" + sectionId);
		var previewEl = document.getElementById("cld-color-preview-" + sectionId);
		var labelEl = document.getElementById(
			"cld-color-trigger-text-" + sectionId
		);
		if (!field || !trigger) return;

		var colors =
			(window.CLD_OPTION_SETTINGS && window.CLD_OPTION_SETTINGS.colors) || [];
		if (colors.length === 0) {
			field.classList.add("hidden");
			return;
		}

		var NONE_VALUE = "指定なし";
		var NONE_BG =
			"repeating-linear-gradient(45deg,#ddd 0,#ddd 2px,#fff 2px,#fff 8px)";

		var noneItem =
			'<button type="button" class="cld-option-item cld-option-item--color" data-value="' +
			NONE_VALUE +
			'" data-hex="" data-none="1">' +
			'<span class="cld-option-swatch" style="' +
			NONE_BG +
			'"></span>' +
			'<span class="cld-option-label">' +
			NONE_VALUE +
			"</span>" +
			"</button>";

		var popup = document.createElement("div");
		popup.className = "cld-option-popup hidden";
		popup.setAttribute("role", "dialog");
		popup.setAttribute("aria-modal", "true");
		popup.innerHTML = [
			'<div class="cld-option-popup-overlay"></div>',
			'<div class="cld-option-popup-inner">',
			'<div class="cld-option-popup-header">',
			'<h3 class="cld-option-popup-title">名入れ色を選択</h3>',
			'<button type="button" class="cld-option-popup-close" aria-label="閉じる">',
			'<svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="2">',
			'<line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/>',
			"</svg>",
			"</button>",
			"</div>",
			'<div class="cld-option-items cld-option-items--color">',
			noneItem,
			colors
				.map(function (c) {
					return [
						'<button type="button" class="cld-option-item cld-option-item--color" data-value="' +
							c.value +
							'" data-hex="' +
							(c.hex || "#ccc") +
							'">',
						'<span class="cld-option-swatch" style="background:' +
							(c.hex || "#ccc") +
							'"></span>',
						'<span class="cld-option-label">' + c.value + "</span>",
						c.add > 0
							? '<span class="cld-color-swatch-fee">+¥' +
								Math.round(c.add / 100).toLocaleString("ja-JP") +
								"/部</span>"
							: "",
						"</button>",
					].join("");
				})
				.join(""),
			"</div>",
			"</div>",
		].join("");

		document.body.appendChild(popup);

		var selectedValue = "";

		function openPopup() {
			popup.classList.remove("hidden");
			document.body.style.overflow = "hidden";
			popup.querySelectorAll(".cld-option-item").forEach(function (item) {
				item.classList.toggle(
					"is-selected",
					item.dataset.value === selectedValue
				);
			});
		}

		function closePopup() {
			popup.classList.add("hidden");
			document.body.style.overflow = "";
		}

		function selectColor(value, hex, isNone) {
			selectedValue = value;
			if (hiddenInput) hiddenInput.value = isNone ? "" : value;
			if (previewEl) {
				previewEl.dataset.colorName = isNone ? "" : value;
				previewEl.style.background = isNone ? NONE_BG : hex || "#eee";
			}
			if (labelEl) labelEl.textContent = value;
			popup.querySelectorAll(".cld-option-item").forEach(function (item) {
				item.classList.toggle("is-selected", item.dataset.value === value);
			});
			var estimateEl = document.getElementById("cld-estimate-" + sectionId);
			if (estimateEl && estimateEl._triggerUpdate) estimateEl._triggerUpdate();
			closePopup();
		}

		trigger.addEventListener("click", openPopup);
		popup
			.querySelector(".cld-option-popup-overlay")
			.addEventListener("click", closePopup);
		popup
			.querySelector(".cld-option-popup-close")
			.addEventListener("click", closePopup);
		popup.querySelectorAll(".cld-option-item").forEach(function (item) {
			item.addEventListener("click", function () {
				selectColor(item.dataset.value, item.dataset.hex, !!item.dataset.none);
			});
		});

		// 初期状態：「指定なし」を選択済みにする
		selectColor(NONE_VALUE, "", true);
	}

	/* =====================================================
     特急対応トグル
     ===================================================== */
	function initExpressToggle(sectionId) {
		var field = document.getElementById("cld-express-field-" + sectionId);
		var checkbox = document.getElementById("cld-express-check-" + sectionId);
		var hiddenInput = document.getElementById("cld-express-val-" + sectionId);
		if (!field || !checkbox) return;

		var expressSurcharge =
			(window.CLD_OPTION_SETTINGS && window.CLD_OPTION_SETTINGS.expressSurcharge) || 0;
		if (!expressSurcharge) return;

		field.classList.remove("hidden");

		function slideIn(el) {
			if (!el) return;
			requestAnimationFrame(function() {
				el.style.transition = 'opacity 0.3s ease, transform 0.3s ease';
				el.style.opacity = '1';
				el.style.transform = 'translateX(0)';
				el.style.pointerEvents = '';
			});
		}
		function slideOut(el) {
			if (!el) return;
			el.style.transition = 'opacity 0.25s ease, transform 0.25s ease';
			el.style.opacity = '0';
			el.style.transform = 'translateX(-30px)';
			el.style.pointerEvents = 'none';
		}

		checkbox.addEventListener("change", function () {
			if (hiddenInput) hiddenInput.value = checkbox.checked ? "1" : "0";
			// バナー切り替え（フェードアニメーション）
			var bannerCampaign = document.getElementById("cld-banner-campaign-" + sectionId);
			var bannerExpress = document.getElementById("cld-banner-express-" + sectionId);
			if (checkbox.checked) {
				slideOut(bannerCampaign);
				slideIn(bannerExpress);
			} else {
				slideOut(bannerExpress);
				slideIn(bannerCampaign);
			}
			// 価格テーブルラベル切り替え
			var labelCampaign = document.getElementById("cld-ptbl-label-campaign-" + sectionId);
			if (labelCampaign) labelCampaign.style.display = checkbox.checked ? "none" : "";
			var ptblLabel = document.getElementById("cld-ptbl-label-" + sectionId);
			if (ptblLabel) ptblLabel.textContent = checkbox.checked ? "特急価格単価（税抜）" : "単価（税抜）";
			// 価格セル書き換え
			var priceTbl = document.querySelector(".cld-pdp-price-tbl");
			if (priceTbl) {
				var priceCells = priceTbl.querySelectorAll("td[data-rule-discount]");
				var basePrice = window.CLD_PRODUCT_DATA && window.CLD_PRODUCT_DATA.price / 100;
				priceCells.forEach(function(td) {
					var rulePct = parseFloat(td.dataset.ruleDiscount);
					if (isNaN(rulePct) || !basePrice) return;
					if (checkbox.checked) {
						var expressBase = Math.round(basePrice * (1 + expressSurcharge / 100));
						var expressPrice = Math.round(expressBase * rulePct / 100);
						td.innerHTML = expressPrice + "円";
					} else {
						// 元のHTMLを復元（ページロード時のコンテンツを保持）
						if (td.dataset.originalHtml !== undefined) {
							td.innerHTML = td.dataset.originalHtml;
						}
					}
				});
			}
			// コンパクト価格テーブル（単価表示）を更新
			var ptblUnitTh = document.getElementById("cld-ptbl-unit-th-" + sectionId);
			var ptblUnitTd = document.getElementById("cld-ptbl-unit-td-" + sectionId);
			if (ptblUnitTh && ptblUnitTd && ptblUnitTd.dataset.expressPrice) {
				if (checkbox.checked) {
					ptblUnitTd.dataset.originalHtml = ptblUnitTd.innerHTML;
					ptblUnitTh.dataset.originalHtml = ptblUnitTh.innerHTML;
					ptblUnitTd.innerHTML = '<span style="color:#CC0000;font-weight:700">' + ptblUnitTd.dataset.expressPrice + '</span><span class="cld-pdp-ptbl__unit" style="color:#CC0000">円/部</span><span class="cld-pdp-ptbl__tax">（税抜）</span>';
					ptblUnitTh.innerHTML = '特急価格単価<span class="cld-pdp-ptbl__note">※100部</span>';
				} else {
					if (ptblUnitTd.dataset.originalHtml !== undefined) ptblUnitTd.innerHTML = ptblUnitTd.dataset.originalHtml;
					if (ptblUnitTh.dataset.originalHtml !== undefined) ptblUnitTh.innerHTML = ptblUnitTh.dataset.originalHtml;
				}
			}
			// 見積もり更新
			var estimateEl = document.getElementById("cld-estimate-" + sectionId);
			if (estimateEl && estimateEl._triggerUpdate) estimateEl._triggerUpdate();
		});
		// 価格セルの初期HTMLを保存
		var priceTbl = document.querySelector(".cld-pdp-price-tbl");
		if (priceTbl) {
			priceTbl.querySelectorAll("td[data-rule-discount]").forEach(function(td) {
				td.dataset.originalHtml = td.innerHTML;
			});
		}
	}

	/* =====================================================
     名入れフォーム：カートに fee item があれば表示
     ===================================================== */
	function initImprintForm(sectionId) {
		var toggleBtn = document.getElementById("cld-imprint-toggle-" + sectionId);
		var formEl = document.getElementById("cld-imprint-form-" + sectionId);
		if (!toggleBtn || !formEl) return;

		// デフォルト：フォーム表示・トグルボタン非表示（Liquid 側で hidden クラス付与済み）
		// カートに _fee_for を持つ fee item がある場合のみ反転
		fetch("/cart.js")
			.then(function (res) {
				return res.json();
			})
			.then(function (cart) {
				var hasFeeItem = cart.items.some(function (item) {
					return item.properties && item.properties["_fee_for"];
				});
				if (hasFeeItem) {
					var sectionEl = document.getElementById("cld-imprint-" + sectionId);
					if (sectionEl)
						sectionEl.classList.add("cld-imprint-section--has-toggle");
					formEl.classList.add("hidden");
					toggleBtn.classList.remove("hidden");
				}
			})
			.catch(function () {
				/* カート取得失敗時はフォームをそのまま表示 */
			});

		// トグルボタンでフォームを開閉
		toggleBtn.addEventListener("click", function () {
			var isOpen = !formEl.classList.contains("hidden");
			if (isOpen) {
				formEl.classList.add("hidden");
				toggleBtn.textContent = "顧客情報・名入れ項目を入力する ▼";
			} else {
				formEl.classList.remove("hidden");
				toggleBtn.textContent = "顧客情報・名入れ項目を閉じる ▲";
			}
		});

		initVisibleRequired(sectionId);
		initSplitInputs(sectionId);
		initZipCode(sectionId, "cust-");
		initZipCode(sectionId, "");
		initCopyCustomer(sectionId);
		initDeliveryDate(sectionId);
		initFileUpload(sectionId);
		initImprintHistory(sectionId);
	}

	/* =====================================================
     名入れ情報の必須項目（data-cld-required）：表示中のときだけ必須にする
     （fee item ありでフォームを閉じている時・「昨年どおり」選択時は
       非表示の必須項目でカート追加が止まらないようにする）
     ===================================================== */
	function initVisibleRequired(sectionId) {
		var pdpForm = document.getElementById("cld-pdp-form-" + sectionId);
		if (!pdpForm) return;
		var fields = pdpForm.querySelectorAll("[data-cld-required]");
		if (!fields.length) return;

		// 送信ボタンのクリック（Enter による送信を含む）はブラウザの入力チェックより先に届く
		pdpForm.addEventListener(
			"click",
			function (e) {
				if (!e.target.closest('[type="submit"]')) return;
				fields.forEach(function (el) {
					el.required = el.offsetParent !== null;
				});
			},
			true
		);
	}

	/* =====================================================
     注文履歴ラジオ：「昨年どおり」選択時にデザイン・会社情報・入稿データを非表示
     ===================================================== */
	function initImprintHistory(sectionId) {
		var radios = document.querySelectorAll(
			'input[name="properties[注文履歴]"]'
		);
		if (!radios.length) return;

		var designGroup = document.getElementById(
			"cld-imprint-design-" + sectionId
		);
		var companyGroup = document.getElementById(
			"cld-imprint-company-" + sectionId
		);
		var fileField = document.getElementById("cld-imprint-file-" + sectionId);

		function applyVisibility(value) {
			var hide = value === "昨年どおり";
			[designGroup, companyGroup, fileField].forEach(function (el) {
				if (!el) return;
				if (hide) {
					el.classList.add("hidden");
				} else {
					el.classList.remove("hidden");
				}
			});
		}

		radios.forEach(function (radio) {
			radio.addEventListener("change", function () {
				applyVisibility(this.value);
			});
		});

		// 初期状態を反映
		var checked = document.querySelector(
			'input[name="properties[注文履歴]"]:checked'
		);
		if (checked) applyVisibility(checked.value);
	}

	/* =====================================================
     郵便番号・電話番号・FAX番号の分割入力：「-」つなぎの値を hidden に入れる
     （注文情報・メールで表記を「-」ありに統一するため）
     ===================================================== */
	// 全角数字を半角にして数字以外を除く
	function toDigits(str) {
		return String(str || "")
			.replace(/[０-９]/g, function (c) {
				return String.fromCharCode(c.charCodeAt(0) - 0xfee0);
			})
			.replace(/[^\d]/g, "");
	}

	// 区切りなしで貼り付けられた番号を各入力欄の桁に振り分ける
	function splitDigits(type, digits) {
		if (type === "zip") {
			return digits.length === 7 ? [digits.slice(0, 3), digits.slice(3)] : null;
		}
		var lens = null;
		if (digits.length === 11) {
			lens = [3, 4, 4]; // 携帯・IP電話（090-1234-5678）
		} else if (digits.length === 10) {
			if (/^0(120|800)/.test(digits)) lens = [4, 3, 3];
			else if (/^0[36]/.test(digits)) lens = [2, 4, 4];
			else lens = [3, 3, 4];
		}
		if (!lens) return null;
		var parts = [];
		var pos = 0;
		lens.forEach(function (len) {
			parts.push(digits.slice(pos, pos + len));
			pos += len;
		});
		return parts;
	}

	function updateSplitValue(wrap) {
		var hidden = wrap.querySelector("[data-cld-split-value]");
		if (!hidden) return;
		var values = [];
		wrap.querySelectorAll(".cld-split-part").forEach(function (el) {
			if (el.value) values.push(el.value);
		});
		hidden.value = values.join("-");
	}

	function initSplitInputs(sectionId) {
		var pdpForm = document.getElementById("cld-pdp-form-" + sectionId);
		if (!pdpForm) return;

		var wraps = pdpForm.querySelectorAll("[data-cld-split]");

		// ブラウザの入力復元・送信直前にも hidden の値を合わせる
		wraps.forEach(updateSplitValue);
		pdpForm.addEventListener(
			"click",
			function (e) {
				if (e.target.closest('[type="submit"]')) wraps.forEach(updateSplitValue);
			},
			true
		);

		wraps.forEach(function (wrap) {
			var type = wrap.getAttribute("data-cld-split");
			var parts = Array.prototype.slice.call(
				wrap.querySelectorAll(".cld-split-part")
			);

			parts.forEach(function (el, i) {
				el.addEventListener("input", function () {
					var digits = toDigits(el.value);
					if (digits !== el.value) el.value = digits;
					updateSplitValue(wrap);
					// 桁がそろったら次の欄へ
					if (
						parts[i + 1] &&
						el.value.length >= el.maxLength &&
						el.selectionStart === el.value.length
					) {
						parts[i + 1].focus();
					}
				});

				// 1つの欄に番号全体を貼り付けた場合は振り分ける
				el.addEventListener("paste", function (e) {
					var text = (e.clipboardData || window.clipboardData).getData("text");
					var groups = String(text || "")
						.split(/[^\d０-９]+/)
						.map(toDigits)
						.filter(Boolean);
					var values = null;
					if (groups.length === parts.length) {
						values = groups;
					} else if (groups.length === 1 && groups[0].length > el.maxLength) {
						values = splitDigits(type, groups[0]);
					}
					if (!values) return;
					e.preventDefault();
					parts.forEach(function (part, j) {
						part.value = (values[j] || "").slice(0, part.maxLength);
					});
					updateSplitValue(wrap);
					// コピー判定・住所検索に入力を伝える
					var ev = new Event("input", { bubbles: true });
					ev.cldUserInput = true;
					parts[parts.length - 1].dispatchEvent(ev);
				});

				// 空の欄で Backspace を押したら前の欄へ戻る
				el.addEventListener("keydown", function (e) {
					if (e.key === "Backspace" && !el.value && parts[i - 1]) {
						parts[i - 1].focus();
					}
				});
			});
		});
	}

	/* =====================================================
     郵便番号自動補完（prefix: 顧客情報 "cust-" / 会社情報 ""）
     ===================================================== */
	function initZipCode(sectionId, prefix) {
		var zipInput = document.getElementById("cld-" + prefix + "zip-" + sectionId);
		var statusEl = document.getElementById(
			"cld-" + prefix + "zip-status-" + sectionId
		);
		var prefInput = document.getElementById("cld-" + prefix + "pref-" + sectionId);
		var cityInput = document.getElementById("cld-" + prefix + "city-" + sectionId);
		var wrap = zipInput && zipInput.closest("[data-cld-split]");
		if (!zipInput || !wrap) return;

		var timer;
		var lastZip = "";
		wrap.addEventListener("input", function () {
			clearTimeout(timer);
			var raw = zipInput.value.replace(/[^\d]/g, "");
			if (raw.length !== 7 || raw === lastZip) return;
			lastZip = raw;

			statusEl.textContent = "検索中…";
			statusEl.dataset.state = "loading";
			timer = setTimeout(function () {
				fetch("https://zipcloud.ibsnet.co.jp/api/search?zipcode=" + raw)
					.then(function (res) {
						return res.json();
					})
					.then(function (data) {
						if (data.results && data.results[0]) {
							var r = data.results[0];
							if (prefInput) {
								// select の場合は value を直接セット（テキストでも動作）
								prefInput.value = r.address1;
							}
							if (cityInput) cityInput.value = r.address2 + r.address3;
							statusEl.textContent = "住所を自動入力しました";
							statusEl.dataset.state = "ok";
							// 顧客情報のコピー中なら会社情報にも反映させる
							if (cityInput)
								cityInput.dispatchEvent(new Event("change", { bubbles: true }));
						} else {
							statusEl.textContent = "該当する住所が見つかりません";
							statusEl.dataset.state = "error";
						}
					})
					.catch(function () {
						lastZip = "";
						statusEl.textContent = "住所の取得に失敗しました";
						statusEl.dataset.state = "error";
					});
			}, 400);
		});
	}

	/* =====================================================
     会社情報：「顧客情報と同じ内容を使う」
     - 押すと顧客情報をコピーして会社情報の入力欄を折りたたむ
     - 「内容を確認する」で開閉でき、開くとコピーされた内容を確認できる
     - コピー中は顧客情報の変更を会社情報にも反映する
     - 会社情報を直接編集した時・「解除する」でコピーをやめる（入力内容は残す）
     - コピー中は会社情報の各項目を送信せず、properties[会社情報] = 顧客情報と同じ を送る
       （カート・注文メールで同じ内容が二重に並ばないようにする）
     ===================================================== */
	function initCopyCustomer(sectionId) {
		var box = document.getElementById("cld-copy-customer-" + sectionId);
		var customer = document.getElementById("cld-customer-fields-" + sectionId);
		var company = document.getElementById("cld-company-fields-" + sectionId);
		if (!box || !customer || !company) return;

		var copyBtn = box.querySelector("[data-cld-copy-customer]");
		var status = box.querySelector("[data-cld-copy-status]");
		var toggleBtn = box.querySelector("[data-cld-copy-toggle]");
		var cancelBtn = box.querySelector("[data-cld-copy-cancel]");
		var flag = box.querySelector("[data-cld-copy-flag]");
		var copying = false;

		// コピー中は会社情報の name を外して送信対象から除く
		function setCopying(on) {
			copying = on;
			if (flag) flag.disabled = !on;
			company.querySelectorAll(on ? "[name]" : "[data-cld-name]").forEach(function (el) {
				if (on) {
					el.setAttribute("data-cld-name", el.name);
					el.removeAttribute("name");
				} else {
					el.name = el.getAttribute("data-cld-name");
					el.removeAttribute("data-cld-name");
				}
			});
		}

		function copyAll() {
			customer.querySelectorAll("[data-cld-field]").forEach(function (src) {
				var key = src.getAttribute("data-cld-field");
				var dest = company.querySelector('[data-cld-field="' + key + '"]');
				if (dest) dest.value = src.value;
			});
		}

		function setOpen(open) {
			company.classList.toggle("hidden", !open);
			toggleBtn.setAttribute("aria-expanded", open ? "true" : "false");
			toggleBtn.textContent = open ? "内容を閉じる ▲" : "内容を確認する ▼";
		}

		function stopCopying() {
			setCopying(false);
			copyBtn.classList.remove("hidden");
			status.classList.add("hidden");
			setOpen(true);
		}

		copyBtn.addEventListener("click", function () {
			setCopying(true);
			copyAll();
			copyBtn.classList.add("hidden");
			status.classList.remove("hidden");
			setOpen(false);
		});

		toggleBtn.addEventListener("click", function () {
			setOpen(company.classList.contains("hidden"));
		});

		cancelBtn.addEventListener("click", stopCopying);

		["input", "change"].forEach(function (type) {
			customer.addEventListener(type, function () {
				if (copying) copyAll();
			});
			company.addEventListener(type, function (e) {
				// 住所自動入力などスクリプトからの change は対象外
				if (copying && (e.isTrusted || e.cldUserInput)) stopCopying();
			});
		});
	}

	/* =====================================================
     入稿データ添付：ファイル名表示
     ===================================================== */
	function initFileUpload(sectionId) {
		var fileInput = document.getElementById("cld-file-" + sectionId);
		var fileNameEl = document.getElementById("cld-file-name-" + sectionId);
		if (!fileInput || !fileNameEl) return;

		fileInput.addEventListener("change", function () {
			if (fileInput.files.length > 0) {
				fileNameEl.textContent = fileInput.files[0].name;
				fileNameEl.classList.add("has-file");
			} else {
				fileNameEl.textContent = "未選択";
				fileNameEl.classList.remove("has-file");
			}
		});
	}

	/* =====================================================
     希望納期：flatpickr カレンダー
     ===================================================== */
	function initDeliveryDate(sectionId) {
		var inputEl = document.getElementById("cld-delivery-input-" + sectionId);
		var hiddenInput = document.getElementById("cld-delivery-" + sectionId);
		if (!inputEl || !hiddenInput) return;

		if (typeof flatpickr === "undefined") return;

		flatpickr(inputEl, {
			locale: "ja",
			dateFormat: "Y年m月d日",
			minDate: "today",
			allowInput: true,
			disableMobile: false,
			onChange: function (selectedDates, dateStr) {
				if (selectedDates.length === 0) {
					hiddenInput.value = "";
					return;
				}
				var d = selectedDates[0];
				hiddenInput.value = d.getMonth() + 1 + "月" + d.getDate() + "日";
			},
			onReady: function (selectedDates, dateStr, instance) {
				// カレンダーアイコンをクリックでも開けるように
				instance.calendarContainer.dataset.input =
					"cld-delivery-input-" + sectionId;
			},
		});
	}

	/* =====================================================
     Phase 4：名入れポップアップ（書体・色・パターン）
     ===================================================== */
	function groupFontsByLabel(fonts) {
		var map = {};
		var order = [];
		fonts.forEach(function (f) {
			var key = f.label;
			if (!map[key]) {
				map[key] = { id: f.id, label: f.label, image_ja: "", image_en: "" };
				order.push(key);
			}
			var t = (f.type || "").toLowerCase();
			if (t.indexOf("英") !== -1 || t.indexOf("en") !== -1) {
				map[key].image_en = f.image;
			} else {
				map[key].image_ja = f.image;
			}
		});
		return order.map(function (k) {
			return map[k];
		});
	}

	function initImprintPopups(sectionId) {
		var opts = window.CLD_IMPRINT_OPTIONS;
		if (!opts) return;
		buildOptionPopup(sectionId, "font", groupFontsByLabel(opts.fonts || []));
		var patterns = (opts.patterns || []).slice().sort(function(a, b) {
			var na = parseInt(((a.label || '').match(/\d+$/) || ['0'])[0], 10);
			var nb = parseInt(((b.label || '').match(/\d+$/) || ['0'])[0], 10);
			return na - nb;
		});
		buildOptionPopup(sectionId, "pattern", patterns);
	}

	function buildOptionPopup(sectionId, type, items) {
		var trigger = document.getElementById(
			"cld-imprint-" + type + "-trigger-" + sectionId
		);
		var hidden = document.getElementById(
			"cld-imprint-" + type + "-val-" + sectionId
		);
		var textEl = document.getElementById(
			"cld-imprint-" + type + "-text-" + sectionId
		);
		var previewEl = document.getElementById(
			"cld-imprint-" + type + "-preview-" + sectionId
		);
		if (!trigger || !hidden) return;

		if (items.length === 0) {
			if (textEl) textEl.textContent = "準備中";
			trigger.disabled = true;
			trigger.classList.add("cld-option-trigger--disabled");
			return;
		}

		var titles = {
			font: "名入れ書体を選択",
			color: "名入れ色（文字色）を選択",
			pattern: "名入れパターンを選択",
		};

		var popup = document.createElement("div");
		popup.className = "cld-option-popup hidden";
		popup.setAttribute("role", "dialog");
		popup.setAttribute("aria-modal", "true");
		popup.innerHTML = [
			'<div class="cld-option-popup-overlay"></div>',
			'<div class="cld-option-popup-inner">',
			'<div class="cld-option-popup-header">',
			'<h3 class="cld-option-popup-title">' +
				(titles[type] || "選択") +
				"</h3>",
			'<button type="button" class="cld-option-popup-close" aria-label="閉じる">',
			'<svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="2">',
			'<line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/>',
			"</svg>",
			"</button>",
			"</div>",
			'<div class="cld-option-items cld-option-items--' + type + '">',
			(type === "pattern"
				? '<button type="button" class="cld-option-item cld-option-item--pattern" data-value="指定なし" data-none="1"><span class="cld-option-pattern-placeholder">指定なし</span><span class="cld-option-label">指定なし</span></button>'
				: "") +
				items
					.map(function (item) {
						return buildOptionItem(type, item);
					})
					.join(""),
			"</div>",
			"</div>",
		].join("");
		document.body.appendChild(popup);

		var selectedValue = "";

		function openPopup() {
			popup.classList.remove("hidden");
			document.body.style.overflow = "hidden";
			popup.querySelectorAll(".cld-option-item").forEach(function (el) {
				el.classList.toggle("is-selected", el.dataset.value === selectedValue);
			});
		}

		function closePopup() {
			popup.classList.add("hidden");
			document.body.style.overflow = "";
		}

		// パターンの初期状態：「指定なし」を選択済みにする
		if (type === "pattern") {
			selectedValue = "指定なし";
			hidden.value = "指定なし";
			if (textEl) textEl.textContent = "指定なし";
		}

		trigger.addEventListener("click", openPopup);
		popup
			.querySelector(".cld-option-popup-overlay")
			.addEventListener("click", closePopup);
		popup
			.querySelector(".cld-option-popup-close")
			.addEventListener("click", closePopup);
		popup.querySelectorAll(".cld-option-item").forEach(function (el) {
			el.addEventListener("click", function () {
				var val = el.dataset.value;
				selectedValue = val;
				hidden.value = el.dataset.none ? "" : val;
				if (textEl) textEl.textContent = val;
				if (previewEl && type === "color") {
					previewEl.dataset.colorName = el.dataset.none ? "" : val;
					var hex2 = el.dataset.hex2;
					previewEl.style.background = hex2
						? "linear-gradient(135deg," + el.dataset.hex + "," + hex2 + ")"
						: el.dataset.hex || "#ccc";
					previewEl.style.display = "block";
				}
				popup.querySelectorAll(".cld-option-item").forEach(function (e) {
					e.classList.toggle("is-selected", e === el);
				});
				closePopup();
			});
		});
	}

	function buildOptionItem(type, item) {
		if (type === "color") {
			var swatchStyle = item.hex2
				? "background:linear-gradient(135deg," +
					item.hex +
					"," +
					item.hex2 +
					")"
				: "background:" + (item.hex || "#ccc");
			return (
				'<button type="button" class="cld-option-item cld-option-item--color"' +
				' data-value="' +
				item.label +
				'"' +
				' data-hex="' +
				(item.hex || "") +
				'"' +
				(item.hex2 ? ' data-hex2="' + item.hex2 + '"' : "") +
				">" +
				'<span class="cld-option-swatch" style="' +
				swatchStyle +
				'"></span>' +
				'<span class="cld-option-label">' +
				item.label +
				"</span>" +
				"</button>"
			);
		}
		if (type === "font") {
			var imgJa = item.image_ja
				? '<img src="' +
					item.image_ja +
					'" alt="' +
					item.label +
					'（日本語）" class="cld-option-font-img" loading="lazy">'
				: '<span class="cld-option-font-img cld-option-font-img--blank"></span>';
			var imgEn = item.image_en
				? '<img src="' +
					item.image_en +
					'" alt="' +
					item.label +
					'（英字）" class="cld-option-font-img" loading="lazy">'
				: '<span class="cld-option-font-img cld-option-font-img--blank"></span>';
			var images =
				'<div class="cld-option-font-images">' + imgJa + imgEn + "</div>";
			return (
				'<button type="button" class="cld-option-item cld-option-item--font"' +
				' data-value="' +
				item.label +
				'">' +
				images +
				'<span class="cld-option-label">' +
				item.label +
				"</span>" +
				"</button>"
			);
		}
		if (type === "pattern") {
			var inner = item.image
				? '<img src="' +
					item.image +
					'" alt="' +
					item.label +
					'" class="cld-option-pattern-img" loading="lazy">'
				: '<span class="cld-option-pattern-placeholder">準備中</span>';
			return (
				'<button type="button" class="cld-option-item cld-option-item--pattern"' +
				' data-value="' +
				item.label +
				'">' +
				inner +
				'<span class="cld-option-label">' +
				item.label +
				"</span>" +
				"</button>"
			);
		}
		return "";
	}

	/* =====================================================
     初期化
     ===================================================== */
	function init() {
		document
			.querySelectorAll(".cld-pdp[data-section-id]")
			.forEach(function (el) {
				var sectionId = el.dataset.sectionId;
				initGallery(sectionId);
				initEstimate(sectionId);
				initColorPicker(sectionId);
				initExpressToggle(sectionId);
				initImprintForm(sectionId);
				initImprintPopups(sectionId);
			});
	}

	/* =====================================================
     色オプション：CLD_IMPRINT_OPTIONS.colors を CLD_OPTION_SETTINGS.colors にセット
     色名・価格・variant_id は Liquid が variant_reference から取得済み
     ===================================================== */
	function buildColorOptions() {
		var opts = window.CLD_IMPRINT_OPTIONS;
		if (!opts || !opts.colors || !opts.colors.length) return;

		window.CLD_OPTION_SETTINGS = window.CLD_OPTION_SETTINGS || {};
		window.CLD_OPTION_SETTINGS.colors = opts.colors.map(function (c) {
			return {
				value: c.name,
				hex: c.hex || "",
				hex2: c.hex2 || "",
				add: 0, // fetchColorFeePrices が variant から取得して上書き
				fee_variant_id: c.fee_variant_id || null,
			};
		});
	}

	/* =====================================================
     色手数料バリアントの実価格を Shopify から取得して反映
     ===================================================== */
	function fetchColorFeePrices(callback) {
		var colors =
			window.CLD_OPTION_SETTINGS && window.CLD_OPTION_SETTINGS.colors;
		if (!colors || !colors.length) {
			callback();
			return;
		}

		var targets = colors.filter(function (c) {
			return c.fee_variant_id;
		});
		if (!targets.length) {
			callback();
			return;
		}

		var fetches = targets.map(function (c) {
			return fetch("/variants/" + c.fee_variant_id + ".js")
				.then(function (res) {
					return res.json();
				})
				.then(function (v) {
					if (v.price != null) {
						c.add = v.price; // Shopify price はすでにセント単位
					} else {
						// バリアントが存在しない（404等）場合はカート追加しないようにクリア
						c.fee_variant_id = null;
					}
				})
				.catch(function () {
					c.fee_variant_id = null;
				});
		});

		Promise.all(fetches).then(callback).catch(callback);
	}

	if (document.readyState === "loading") {
		document.addEventListener("DOMContentLoaded", function () {
			buildColorOptions();
			fetchColorFeePrices(init);
		});
	} else {
		buildColorOptions();
		fetchColorFeePrices(init);
	}
})();
